import { FALLBACK_ID } from "../registry";
import { JsonFallback } from "../JsonFallback";
import { PRIORITY, type ValueRenderer } from "../types";

/** Last-resort renderer: delegates to the existing JSON tree so nested unknown
 *  values still get variable badges, ENS, chain badges and link detection. */
export const FallbackRenderer: ValueRenderer = {
  id: FALLBACK_ID,
  // Never called: registry.ts routes id === FALLBACK_ID to the fallback slot,
  // so resolve() uses this renderer unconditionally, not via match(). The
  // implementation only exists to satisfy the ValueRenderer interface.
  match: () => ({ priority: PRIORITY.FALLBACK }),
  Component: ({ value, ctx }) => <JsonFallback value={value} ctx={ctx} />,
};
